export const iFrameDetect = () => {
  return {
    isWithinIFrame: window.location !== window.parent.location,
  };
};
